export var IProductOption;
(function (IProductOption) {
    let IPrice;
    (function (IPrice) {
        /**
         * Return an instance of IPrice with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IPrice.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(IPrice = IProductOption.IPrice || (IProductOption.IPrice = {}));
    /**
     * POs are used to represent purchasable options to the client, and as such they don't map 1:1 to
     * real DbProductOptions on the database. In fact, we have a few types of "fake" product options,
     * whose tokens come from some place else.
     */
    let Type;
    (function (Type) {
        /**
         * The real ones, the token is a DbProductOption token (`po_`)
         */
        Type["REGULAR"] = "REGULAR";
        /**
         * This was a product option, but has been converted to Mix&Match, and now has a `mmpo_` token.
         */
        Type["MIX_AND_MATCH"] = "MIX_AND_MATCH";
        /**
         * A prepack might generate fake options to be purchased.
         * In this case, the token is from the underlying DbProductCollection (`pc_`)
         */
        Type["PRE_PACK"] = "PRE_PACK";
        /**
         * This PO represents a DISPLAY, which is derived from DbProduct.Type.DISPLAY *
         */
        Type["DISPLAY"] = "DISPLAY";
    })(Type = IProductOption.Type || (IProductOption.Type = {}));
    let OrderabilityType;
    (function (OrderabilityType) {
        OrderabilityType["ORDERABILITY_TYPE_UNKNOWN"] = "ORDERABILITY_TYPE_UNKNOWN";
        OrderabilityType["IMMEDIATE"] = "IMMEDIATE";
        OrderabilityType["PREORDER"] = "PREORDER";
    })(OrderabilityType = IProductOption.OrderabilityType || (IProductOption.OrderabilityType = {}));
    let ProductOptionLevelPrepackState;
    (function (ProductOptionLevelPrepackState) {
        ProductOptionLevelPrepackState["PRODUCT_OPTION_LEVEL_PREPACK_STATE_UNKNOWN"] = "PRODUCT_OPTION_LEVEL_PREPACK_STATE_UNKNOWN";
        /**
         * This product option is a product option level prepack
         */
        ProductOptionLevelPrepackState["ACTIVE"] = "ACTIVE";
        /**
         * This product option is not a product option level prepack now, it used to be one
         */
        ProductOptionLevelPrepackState["INACTIVE"] = "INACTIVE";
    })(ProductOptionLevelPrepackState = IProductOption.ProductOptionLevelPrepackState || (IProductOption.ProductOptionLevelPrepackState = {}));
    /**
     * Return an instance of IProductOption with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IProductOption.build = (partial) => (Object.assign({ prices: [], images: [], variations: [], sizing_quantity: [], wholesale_price_by_quantity_list: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(IProductOption || (IProductOption = {}));
